var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.65,
    fill: "#FFFAF3",
    stroke: "#FFC87F",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98438 5.8951V5M13.9517 5.8951V5",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17773 12.1608L10.0728 11.2657V13.6526",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6364 8.87878H10.2214M5 8.87878H7.31235M11.5641 13.0559V11.8625C11.5641 11.7042 11.627 11.5524 11.7389 11.4405C11.8508 11.3286 12.0026 11.2657 12.1608 11.2657C12.3191 11.2657 12.4709 11.3286 12.5828 11.4405C12.6947 11.5524 12.7576 11.7042 12.7576 11.8625V13.0559C12.7576 13.2142 12.6947 13.366 12.5828 13.4779C12.4709 13.5898 12.3191 13.6527 12.1608 13.6527C12.0026 13.6527 11.8508 13.5898 11.7389 13.4779C11.627 13.366 11.5641 13.2142 11.5641 13.0559Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1608 16.6363H9.77389C7.5236 16.6363 6.39815 16.6363 5.69938 15.937C5 15.2382 5 14.1127 5 11.8624V10.669C5 8.41868 5 7.29323 5.69938 6.59446C6.39815 5.89508 7.5236 5.89508 9.77389 5.89508H12.1608C14.4111 5.89508 15.5366 5.89508 16.2354 6.59446C16.9347 7.29323 16.9347 8.41868 16.9347 10.669V11.8624C16.9347 14.1127 16.9347 15.2382 16.2354 15.937C15.8457 16.3272 15.3235 16.4997 14.5478 16.5755",
    stroke: "black",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.34bfbe9042c4c3c278116d249e4e2d43.svg";
export { ForwardRef as ReactComponent };